export * from './total-text-cell-renderer.component';
